
export const rowsDataInFlatView = (rows) => rows.map(rowItem => rowItem.data)
  .flat()
  .filter(dataItem => dataItem !== undefined);
